import { createContext } from "react";

const ManualTransactionEditContext = createContext({});

export default ManualTransactionEditContext;
